/*
 * the datebase stores whatever dates we send down without modification
 * when they are sent back up to the front end, JS assumes they are UTC
 * and converts them to the local time zone with certain toString methods
 * 
 * this will take the times from UTC and display them
 */
export const displayDate = (date: Date) => {
  const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  return utcDate.toLocaleDateString();
}


// WEBPACK FOOTER //
// ./src/common/utils/index.ts